module.exports = __webpack_public_path__ + "assets/img/solar-panels-10-small.94cf3e58.jpg";